// extracted by mini-css-extract-plugin
export default {"collection-section":"collection_collection-section__x-EhL","subheader":"collection_subheader__pA-eJ","products":"collection_products__fAya0"};